import React from "react";
import PropTypes from "prop-types";

import "./style.scss";

const FeaturedIcon = ({ icon }) => (
  <div className="featured-icon col-6 col-lg">
    <img
      src={icon.node.acfPartials.pIcon.localFile.publicURL}
      alt=""
      className="img-fluid"
    />
    <p
      dangerouslySetInnerHTML={{
        __html: icon.node.acfPartials.pHeading,
      }}
    />
  </div>
);

const FeaturedIconList = ({ icons }) => {
  return (
    <>
      {icons && (
        <div className="featured-icon-list container">
          <div className="row">
            {icons.map((icon, i) => (
              <FeaturedIcon key={i} icon={icon} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

FeaturedIconList.propTypes = {
  icons: PropTypes.arrayOf(PropTypes.any),
};

export default FeaturedIconList;
